
import ViewModel from '@/models/ViewModel'
import {
  Component, Prop, Ref, Vue, Watch,
} from 'vue-property-decorator'
import IconAction from '@/components/IconAction/IconAction.vue'
import FormInput from '@/components/FormInput/FormInput.vue'
import SelectPicker from '@/components/SelectPicker/SelectPicker.vue'
import WebMessage from '@/models/WebMessage'
import { Segment } from '@/models/interface/SegmentTargeting'
import CustomTargetingSelect from '@/components/CustomTargeting/CustomTargetingSelect.vue'
import CustomTargetingModule from '@/models/CustomTargeting'

@Component({
  components: {
    FormInput,
    IconAction,
    SelectPicker,
    CustomTargetingSelect,
  },
})
export default class CustomTargetting extends ViewModel {
  @Prop()
  public value!: any

  public ready: boolean = false

  public custom_key_value_list: any[] = []

  public segments: Segment[] = []

  @Watch('segments')
  public onSegmentsChange(newValue: Segment[]) {
    if (!newValue) return
    this.$emit('input', newValue)
  }

  public get options_lists() {
    return {
      actions: CustomTargetingModule.actions_option,
      types: CustomTargetingModule.types_option,
    }
  }

  public mounted() {
    this.segments = CustomTargetingModule.mapToSegment(this.value)
    this.loadTags()
  }

  public removeTarget(segment_id: any, id: string) {
    this.ready = false

    const index = this.segments.findIndex(segment => segment.id === segment_id)

    let found = this.segments[index].conditions.findIndex(condition => condition.id === id)

    if (found !== -1) {
      this.segments[index].conditions.splice(found, 1)
    }

    if (!this.segments[index].conditions.length) {
      // get updated index
      found = this.segments.findIndex(segment => segment.id === segment_id)
      this.segments.splice(found, 1)
    }

    this.ready = true
  }

  public clearAll() {
    this.segments = []
  }

  public addSegment() {
    const segment: Segment = CustomTargetingModule.createSegment()
    this.segments.push(segment)
  }

  public addSegmentKeyValue(args: { tag: string; segment_index: number; condition_index: number }) {
    const { tag, segment_index, condition_index } = args

    this.custom_key_value_list.push({
      name: tag,
      value: tag,
      type: 'key_value',
    })

    this.segments[segment_index].conditions[condition_index].ids.push(tag)
  }

  public addCondition(index: number) {
    this.segments[index].conditions.push(CustomTargetingModule.newCondition())
  }

  public clearOnChange(args: any) {
    if ((args.e.item === 'key_value' && args.oldVal === 'segment') || args.e.item === 'key_value') {
      this.segments[args.index].conditions[args.conditionIndex].ids = []
    }

    if ((args.e.item === 'segment' && args.oldVal === 'key_value') || args.e.item === 'segment') {
      this.segments[args.index].conditions[args.conditionIndex].ids = []
    }
  }

  public loadTags() {
    this.custom_key_value_list = []
    this.segments.forEach(segment => {
      segment.conditions.forEach(condition => {
        condition.ids.forEach((id: string) => {
          if (condition.type === 'key_value') {
            this.custom_key_value_list.push({
              name: id,
              value: id,
              type: condition.type,
            })
          }
        })
      })
    })
    this.ready = true
  }
}
